import clsx from 'clsx';
import { getFormattedDate } from '@frameio/utils';
import { Text } from '@frameio/vapor';
import styles from './DateFieldMatch.module.css';

type DateFieldMatchProps = {
  date: string;
  variant?: 'block' | 'inline';
};

export const DateFieldMatch = ({
  date,
  variant = 'block',
}: DateFieldMatchProps) => {
  const parsedDate = new Date(date);
  const isValidDate = !isNaN(parsedDate.getTime());

  const formatted = getFormattedDate({
    date: parsedDate,
    returnBothDateAndTime: variant === 'block',
  });
  const displayDate = formatted.formattedDate || date;

  return (
    <div
      className={clsx(styles.container, variant === 'inline' && styles.inline)}
    >
      <Text color="tertiary" fontWeight="regular" variant="caption">
        {isValidDate ? displayDate : 'Invalid Date'}
      </Text>
    </div>
  );
};
